import React from 'react';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Turnero from './pages/calendar'
import Forms from './pages/Forms';
import Ddjj from './pages/Ddjj';
import Create from './pages/Create';
import Login from './pages/Login';
import MisTurnos from './pages/MisTurnos';
import Blog from './pages/Blog';
import About from './pages/About';
import AdminPanel from './pages/AdminPanel';
import UserDetail from './components/AdminPanel/UserDetail';
import Consentimiento from './pages/Consentimiento';
import Comprobante from './pages/Comprobante';
import DdjjMedico from './components/Forms/DeclaracionJurada/DdjjMedico'
import Anexo from './components/Forms/ConsentimientoBilateral/Anexo'
import MisFormularios from './pages/MisFormularios';
import DDJJ from './components/UserForms/DDJJ';
import AnexoUser from './components/UserForms/AnexoUser'
import Renovaciones from './pages/Renovaciones'
import RenovacionDDJJ from './pages/RenovacionDDJJ';
import AnexoDocRenovado from './components/AdminPanel/AnexoDocRenovado';
import AnexoUsuario from './pages/AnexoUsuario'
import RenovacionConsentimiento from './pages/RenovacionConsentimiento';
import RenovacionAnexoUser from './components/UserForms/RenovacionAnexoUser'
import RenovacionDDJJUser from './components/UserForms//RenovacionDDJJ';
import DdjjMedicoNuevo from './components/Forms/DeclaracionJurada/DdjjMedicoNuevo';




const App = ():JSX.Element => {
  return (
    <Router>
      <Routes>      
        <Route path='/' element={<Home />} />
        <Route path='/turnero' element={<Turnero />} />
        <Route path='/formularios' element={<Forms />} />
        <Route path='/declaracionjurada' element={<Ddjj />} />
        <Route path='/createaccount' element={<Create />} />
        <Route path='/login' element={<Login />} />
        <Route path='/misturnos' element={<MisTurnos />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/about' element={<About />} />
        <Route path='/adminpanel' element={<AdminPanel />} />
        <Route path="/adminpanel/:userId" element={<UserDetail />} />
        <Route path="/consentimientobilateral" element={<Consentimiento />} />
        <Route path='/comprobante/:turnoId' element={<Comprobante/>} />
        <Route path='/completarddjjdoc/:userId' element={<DdjjMedico/>} />
        <Route path='/completarddjjdocRenovado/:userId' element={<DdjjMedicoNuevo/>} />
        <Route path='/completaranexodoc/:userId' element={<Anexo />} />
        <Route path='/misformularios' element={<MisFormularios />} />
        <Route path='/anexousuario' element={<AnexoUsuario />} />
        <Route path='/userDDJJ' element={<DDJJ />} />
        <Route path='/AnexoUser' element={<AnexoUser />} />
        <Route path='/AnexoUserNuevo' element={<RenovacionAnexoUser />} />
        <Route path='/renovaciones' element={<Renovaciones />} />
        <Route path='/renovacionddjj' element={<RenovacionDDJJ />} />
        <Route path='/RenovacionDDJJUser' element={<RenovacionDDJJUser />} />
        <Route path='/renovacionConsentimiento' element={<RenovacionConsentimiento/>} />
        <Route path='/completaranexodocRenovado/:userId' element={<AnexoDocRenovado /> } /> 
      </Routes>
    </Router>
  );
}

export default App;

